import { useState, useEffect } from "react"

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const ExerciseFilesTab = ({ lesson }) => {
  const [exerciseFiles, setExerciseFiles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchExerciseFiles = async () => {
      if (!lesson) return

      try {
        const token = localStorage.getItem('access')
        const response = await fetch(`${BASE_URL}/courses/lessons/${lesson.id}/exercise-files/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (!response.ok) {
          throw new Error('Failed to fetch exercise files')
        }

        const data = await response.json()
        setExerciseFiles(data.results || [])
        setLoading(false)
      } catch (err) {
        setError(err.message)
        setLoading(false)
      }
    }

    fetchExerciseFiles()
  }, [lesson])

  const handleDownload = (file) => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a')
    link.href = file.file
    link.download = file.title
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase()
    switch (extension) {
      case 'pdf':
        return 'fas fa-file-pdf text-danger'
      case 'doc':
      case 'docx':
        return 'fas fa-file-word text-primary'
      case 'ppt':
      case 'pptx':
        return 'fas fa-file-powerpoint text-warning'
      case 'xls':
      case 'xlsx':
        return 'fas fa-file-excel text-success'
      default:
        return 'fas fa-file text-muted'
    }
  }

  if (loading) {
    return (
      <div className="exercise-files-tab">
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden"></span>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="exercise-files-tab">
        <div className="alert alert-danger">
          <h6>Error Loading Exercise Files</h6>
          <p>{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="exercise-files-tab">
      <h5 className="mb-4">Exercise Files</h5>
      {exerciseFiles.length === 0 ? (
        <div className="text-center text-muted">
          <i className="fas fa-folder-open fa-3x mb-3"></i>
          <p>No exercise files available for this lesson.</p>
        </div>
      ) : (
        <div className="files-grid">
          {exerciseFiles.map((file) => (
            <div key={file.id} className="file-card" onClick={() => handleDownload(file)}>
              <div className="file-icon">
                <i className={getFileIcon(file.title)}></i>
              </div>
              <div className="file-info">
                <h6 className="file-name">{file.title}</h6>
                {/*<span className="file-size text-muted">Size: {file.size || 'Unknown'}</span>*/}
              </div>
              <div className="download-icon">
                <i className="fas fa-download text-warning"></i>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ExerciseFilesTab